import React, { useState, useEffect } from 'react';
import { Typography, Box } from '@mui/material';

interface InfoBannerProps {
  messages?: string[];
  speed?: number; // Speed in milliseconds
}

const InfoBanner: React.FC<InfoBannerProps> = ({ 
  messages = [
    "Welcome to NeighborhoodPulse_SA - Your trusted local services directory!",
    "Find vetted service providers in your neighborhood - Quality guaranteed!",
    "New providers joining daily - Check out our latest additions!",
    "Have feedback? We'd love to hear from you - Help us improve!",
    "Building stronger communities through reliable local services!"
  ], 
  speed = 6000 
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, speed);

    return () => clearInterval(interval);
  }, [messages.length, speed]);

  if (!messages || messages.length === 0) {
    return null;
  }

  return (
    <Box 
      sx={{ 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        py: 1.5,
        px: 2,
        borderRadius: 1,
        mb: 3,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        width: '100%'
      }}
    >
      <Box
        sx={{
          background: '#ff6b6b',
          color: 'white',
          px: 2,
          py: 0.5,
          borderRadius: 10,
          fontWeight: 'bold',
          fontSize: '0.9rem',
          whiteSpace: 'nowrap',
          flexShrink: 0
        }}
      >
        Information
      </Box>
      <Box sx={{ flex: 1, overflow: 'hidden', position: 'relative', height: 24 }}>
        <Typography 
          variant="body2" 
          sx={{ 
            color: 'white',
            fontSize: '0.95rem',
            whiteSpace: 'nowrap',
            display: 'inline-block',
            position: 'absolute',
            left: 0,
            animation: 'slideLeft 18s linear infinite',
            '@keyframes slideLeft': {
              '0%': { 
                transform: 'translateX(100%)'
              },
              '100%': { 
                transform: 'translateX(-100%)'
              }
            }
          }}
        >
          {messages[currentIndex]}
        </Typography>
      </Box>
    </Box>
  );
};

export default InfoBanner; 